import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'block-update');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'provider',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'calendar',
    'blocked_slots',
    {
      type: 'payload',
      selector: ['slotId'],
    },
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/blockslot-update-req.js